/**
* @brandOverride URBNWeb
*/
import {
    init as productRegistryInit
} from './productRegistryComponent';

import {
    init as productRegistryMultipleInit
} from './productRegistryMultipleComponent';

function complexSoldOut(store) {
    return !store.getState().product.productUnavailable;
}

const complexSoldOutOverides = {
    isComponentValid: complexSoldOut
};

export const productComponentConfigOverride = {
    children: [
        [productRegistryInit, complexSoldOutOverides],
        [productRegistryMultipleInit, complexSoldOutOverides]
    ]
};
